import { NgModule } from '@angular/core';
import { FileUploadPickerComponent } from './file-upload-picker.component';
import { ngfModule } from 'angular-file';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    ngfModule,
    TranslateModule
  ],
  declarations: [
    FileUploadPickerComponent
  ],
  exports: [
    FileUploadPickerComponent
  ]
})
export class FileUploadPickerModule {}
